import { render, staticRenderFns } from "./Service_settled.vue?vue&type=template&id=afe6c56e&scoped=true"
import script from "./Service_settled.vue?vue&type=script&lang=js"
export * from "./Service_settled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe6c56e",
  null
  
)

export default component.exports